import api from '@/api';
import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';
import { SET_MARKETPLACE, SET_IS_MARKETPLACE_EXACT_MATCH, SET_MARKETPLACE_FILTER_BY_FEATURE_TYPE } from './mutations';
const buildMarketplaceActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);
// actions declarations
export const getMarketplace = buildMarketplaceActionObject('getMarketplace');
export const setIsMarketplaceExactMatch = buildMarketplaceActionObject('setIsMarketplaceExactMatch');
export const setMarketplaceFilterByFeatureType = buildMarketplaceActionObject('setMarketplaceFilterByFeatureType');
const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getMarketplace.action]({ commit, state }, { id, forceGet }) {
		const needToGet = !state.marketplace;
		if (needToGet || forceGet) {
			const marketplace = await api.getMarketplace(id);
			commit(SET_MARKETPLACE, marketplace);
		}
		return state.marketplace;
	},
	[setIsMarketplaceExactMatch.action]({ commit }, { isMarketplaceExactMatch }) {
		commit(SET_IS_MARKETPLACE_EXACT_MATCH, isMarketplaceExactMatch);
	},
	[setMarketplaceFilterByFeatureType.action]({ commit }, { marketplaceFilterByFeatureType }) {
		commit(SET_MARKETPLACE_FILTER_BY_FEATURE_TYPE, marketplaceFilterByFeatureType);
	},
};

export default actions;
